import { useEffect, useState } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

// Next.js seems to sometimes ignore changes done with `pushState`.
// Custom hook to store and return pathname and SearchParams as state
export const useCategoryLocation = () => {
    const initialPathname = usePathname();
    const initialSearchParams = useSearchParams();

    const [pathname, setPathname] = useState(initialPathname);
    const [searchParams, setSearchParams] = useState<URLSearchParams>(initialSearchParams);

    useEffect(() => {
        const updateState = () => {
            const url = new URL(window.location.href);
            setPathname(url.pathname);
            setSearchParams(url.searchParams);
        };

        window.addEventListener('popstate', updateState);

        return () => window.removeEventListener('popstate', updateState);
    }, []);

    return { pathname, searchParams };
};
